module.exports = __webpack_public_path__ + "static/img/customer.e409a93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/customer/customer.png
// module id = 34di
// module chunks = 0